import React from "react";
import styled from "styled-components";

import { Spinner } from "lib/helpers/fetchData";

const StyledLoading = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Loading = () => {
  return (
    <StyledLoading className="loading">
      <Spinner />
    </StyledLoading>
  );
};
